import { OptionFloating, OptionsFloatings } from '@comfama/comfama-ui-react';
import { ServiceChannel } from '@comfama/frontend-utils';
import React, { useEffect, useState } from 'react';

const serviceChannelClass = new ServiceChannel();

const ServiceChannels: React.FC = () => {
    const [channels, setChannels] = useState<OptionFloating[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadChannels = async () => {
            setIsLoading(true);
            const data = await serviceChannelClass.fetch();
            const rawData =
                data && data.length > 0
                    ? data
                    : OptionsFloatings.defaultOptions;
            setChannels(rawData);
            setIsLoading(false);
        };

        loadChannels();
    }, []);

    if (isLoading && channels.length === 0) {
        return null;
    }

    if (channels.length === 0) {
        return null;
    }

    return <OptionsFloatings channels={channels} />;
};

export default ServiceChannels;
